import { RootState } from '../../../app/store'
import { CrmObjectName, ReduxCrmKey } from '../types'

export const getSchemaStatus =
  (crmKey: ReduxCrmKey | undefined, objectName: CrmObjectName | undefined) => (state: RootState) =>
    crmKey && objectName ? state.crm[crmKey]?.schema?.[objectName]?.status : undefined
